import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Table, Button, Form, Modal, Badge, Spinner, Pagination } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import distributorService from '../../../../services/DistributorService';

const FOSCollectionHistory = () => {
  const {fosId,profileId} = useParams();
  const navigate = useNavigate();
  
  console.log("profileId:",profileId,"fosId:",fosId);



  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [showTransactionModal, setShowTransactionModal] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [balanceSummary, setBalanceSummary] = useState(null);
  const [paymentMode, setPaymentMode] = useState(''); // '' for all, 'CASH', 'UPI'
  const [dateRange, setDateRange] = useState(() => {
    const today = new Date();
    
    return {
      startDate: today.toISOString().split('T')[0],
      endDate: today.toISOString().split('T')[0]
    };
  });
  const [summary, setSummary] = useState({
    totalCredit: 0,
    totalDebit: 0,
    currentBalance: 0,
    transactionCount: 0,
    creditTransactions: 0,
    debitTransactions: 0
  });

  useEffect(() => {
    if (fosId) {
      fetchTransactionHistory();
    }
  }, [fosId]);

  useEffect(() => {
    if (fosId) {
      fetchTransactionHistory();
    }
  }, [dateRange, currentPage, paymentMode]);

  const fetchTransactionHistory = async () => {
    setLoading(true);
    try {
      const params = {
        fos_id: fosId,
        start_date: dateRange.startDate,
        end_date: dateRange.endDate,
        payment_mode: paymentMode,
        page: currentPage,
        limit: 20
      };

      console.log('Fetching FOS transaction history with params:', params);

      const response = await distributorService.getFOSTransactionHistory(params);
      
      if (response.success) {
        // Handle the nested data structure
        const data = response.data;
        
        // Set transactions
        setTransactions(data.transactions || []);
        
        // Set balance summary
        if (data.balance_summary) {
          setBalanceSummary(data.balance_summary);
          
          // Calculate totals from transactions
          const creditAmount = data.transactions
            .filter(t => t.transaction_type === 'CREDIT')
            .reduce((sum, t) => sum + parseFloat(t.amount || 0), 0);
          
          const debitAmount = data.transactions
            .filter(t => t.transaction_type === 'DEBIT')
            .reduce((sum, t) => sum + parseFloat(t.amount || 0), 0);
          
          setSummary({
            totalCredit: creditAmount,
            totalDebit: debitAmount,
            currentBalance: data.balance_summary.current_outstanding || 0,
            transactionCount: data.balance_summary.total_transactions || 0,
            creditTransactions: data.balance_summary.total_credit_transactions || 0,
            debitTransactions: data.balance_summary.total_debit_transactions || 0
          });
        }
        
        // Set pagination
        if (data.pagination) {
          setTotalCount(data.pagination.count || 0);
          setTotalPages(data.pagination.total_pages || 1);
        }
      } else {
        toast.error(response.error || 'Failed to fetch transaction history');
      }
    } catch (error) {
      toast.error('Failed to fetch transaction history');
      console.error('Error fetching transaction history:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDateRangeChange = (field, value) => {
    setDateRange(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const exportToExcel = async () => {
    setExportLoading(true);
    try {
      const params = {
        fosId: fosId,
        startDate: dateRange.startDate,
        endDate: dateRange.endDate,
        paymentMode: paymentMode
      };

      console.log('Exporting FOS ledger with params:', params);

      const response = await distributorService.exportFOSLedger(params);
      
      if (response.success) {
        // The response.data is already a blob from the service
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement('a');
        link.href = url;
        link.download = response.fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        toast.success('FOS Collection History exported successfully');
      } else {
        toast.error(response.error || 'Failed to export FOS ledger');
      }
    } catch (error) {
      toast.error('Failed to export FOS ledger');
      console.error('Error exporting FOS ledger:', error);
    } finally {
      setExportLoading(false);
    }
  };

  const handleTransactionClick = async (transaction) => {
    try {
      const response = await distributorService.getTransactionDetails(transaction.id);
      if (response.success) {
        setSelectedTransaction(response.data);
        setShowTransactionModal(true);
      } else {
        toast.error('Failed to fetch transaction details');
      }
    } catch (error) {
      toast.error('Failed to fetch transaction details');
      console.error('Error fetching transaction details:', error);
    }
  };

  const getTransactionTypeColor = (type) => {
    return type === 'CREDIT' ? 'text-success' : 'text-danger';
  };


  return (
    <Container fluid className="py-1">
      {/* Header */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <Button 
            variant="outline-primary" 
            onClick={() => navigate('/distributor/collect/fos-collection')}
            className="me-3"
            title="Back to FOS Collection"
          >
            <i className="fas fa-arrow-left"></i>
          </Button>
          <h5 style={{ color: '#031a6f', fontWeight: '600', display: 'inline' }}>
            <i className="fas fa-book me-2"></i>
            FOS Collection History
          </h5>
        </div>
        <Button variant="success" onClick={exportToExcel} disabled={exportLoading}>
          <i className="fas fa-file-excel me-2"></i>
          {exportLoading ? 'Exporting...' : 'Export Excel'}
        </Button>
      </div>

      {/* FOS Info Section */}
      {balanceSummary && (
        <Row className="mb-4">
          <Col md={12}>
            <div className="d-flex gap-3 align-items-center bg-light p-3 rounded border">
              <div>
                <small className="text-muted d-block">FOS Name</small>
                <strong>{balanceSummary.fos_name || 'N/A'}</strong>
              </div>
              <div className="border-start ps-3">
                <small className="text-muted d-block">Mobile</small>
                <strong>{balanceSummary.fos_mobile}</strong>
              </div>
              <div className="border-start ps-3">
                <small className="text-muted d-block">Credit Limit</small>
                <strong className="text-primary">₹{parseFloat(balanceSummary.credit_limit || 0).toLocaleString()}</strong>
              </div>
              <div className="border-start ps-3">
                <small className="text-muted d-block">Available Credit</small>
                <strong className="text-success">₹{parseFloat(balanceSummary.available_credit || 0).toLocaleString()}</strong>
              </div>
              <div className="border-start ps-3">
                <small className="text-muted d-block">Current Outstanding</small>
                <strong className="text-danger">₹{parseFloat(balanceSummary.current_outstanding || 0).toLocaleString()}</strong>
              </div>
            </div>
          </Col>
        </Row>
      )}

      {/* Filters */}
      <Row className="mb-4">
        <Col md={3}>
          <Form.Group>
            <Form.Label>Start Date</Form.Label>
            <Form.Control
              type="date"
              value={dateRange.startDate}
              onChange={(e) => handleDateRangeChange('startDate', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={3}>
          <Form.Group>
            <Form.Label>End Date</Form.Label>
            <Form.Control
              type="date"
              value={dateRange.endDate}
              onChange={(e) => handleDateRangeChange('endDate', e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>Payment Mode</Form.Label>
            <Form.Select
              value={paymentMode}
              onChange={(e) => setPaymentMode(e.target.value)}
            >
              <option value="">All</option>
              <option value="CASH">Cash</option>
              <option value="UPI">UPI</option>
            </Form.Select>
          </Form.Group>
        </Col>
        <Col md={2}>
          <Form.Group>
            <Form.Label>&nbsp;</Form.Label>
            <div>
              <Button 
                variant="primary" 
                onClick={fetchTransactionHistory} 
                disabled={loading} 
                title="Apply Filter"
                style={{ 
                  height: '38px', 
                  width: '38px', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center' 
                }}
              >
                <i className="fas fa-filter"></i>
              </Button>
            </div>
          </Form.Group>
        </Col>
      </Row>


      {/* Transactions Table */}
      <div className="table-responsive">
        <Table striped bordered hover className="modern-table">
              <thead>
                <tr>
                  <th>Entry Date</th>
                  <th>Transaction Date</th>
                  <th>Order ID</th>
                  <th>Retailer Name</th>
                  <th>Retailer Mobile</th>
                  <th>Type</th>
                  <th>Amount</th>
                  <th>Closing Balance</th>
                  <th>Payment Mode</th>
                  <th>Collected By Name</th>
                  <th>Collected By Mobile</th>
                  <th>Source</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="12" className="text-center py-4">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : transactions.length === 0 ? (
                  <tr>
                    <td colSpan="12" className="text-center py-4 text-muted">
                      No transactions found
                    </td>
                  </tr>
                ) : (
                  transactions.map((txn) => (
                    <tr key={txn.id}>
                      <td>
                        <div>
                          {txn.created_at ? new Date(txn.created_at).toLocaleDateString() : 'N/A'}
                          <br />
                          <small className="text-muted">
                            {txn.created_at ? new Date(txn.created_at).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }) : ''}
                          </small>
                        </div>
                      </td>
                      <td>
                        <div>{txn.transaction_date ? new Date(txn.transaction_date).toLocaleDateString() : 'N/A'}</div>
                        <small className="text-muted">{txn.transaction_time ? new Date(`1970-01-01T${txn.transaction_time}`).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true }) : ''}</small>
                      </td>
                      <td>
                        <small className="font-monospace">{txn.order_id}</small>
                      </td>
                      <td>
                        {txn.retailer_name || 'N/A'}
                      </td>
                      <td>
                        {txn.retailer_mobile || '-'}
                      </td>
                      <td>
                        <small className="text-muted">{txn.txn_type}</small>
                      </td>
                      <td>
                        <span className={getTransactionTypeColor(txn.transaction_type)}>
                          <strong>{txn.transaction_type === 'CREDIT' ? '+' : '-'}₹{txn.amount?.toLocaleString()}</strong>
                        </span>
                      </td>
                      <td>₹{txn.closing_balance?.toLocaleString()}</td>
                      <td>{txn.payment_mode}</td>
                      <td>
                        {txn.collected_by_name || 'N/A'}
                      </td>
                      <td>
                        {txn.collected_by_mobile || '-'}
                      </td>
                      <td>
                        {txn.source || 'N/A'}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
        </Table>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="d-flex justify-content-between align-items-center mt-4">
          <div>
            Showing {transactions.length > 0 ? ((currentPage - 1) * 20) + 1 : 0} to {Math.min(currentPage * 20, totalCount)} of {totalCount} entries
          </div>
          <Pagination>
            <Pagination.First 
              onClick={() => setCurrentPage(1)} 
              disabled={currentPage === 1} 
            />
            <Pagination.Prev 
              onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))} 
              disabled={currentPage === 1} 
            />
            {[...Array(Math.min(5, totalPages))].map((_, index) => {
              const pageNum = Math.max(1, Math.min(currentPage - 2 + index, totalPages - 4 + index));
              return (
                <Pagination.Item
                  key={pageNum}
                  active={pageNum === currentPage}
                  onClick={() => setCurrentPage(pageNum)}
                >
                  {pageNum}
                </Pagination.Item>
              );
            })}
            <Pagination.Next 
              onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))} 
              disabled={currentPage === totalPages} 
            />
            <Pagination.Last 
              onClick={() => setCurrentPage(totalPages)} 
              disabled={currentPage === totalPages} 
            />
          </Pagination>
        </div>
      )}

      {/* Transaction Details Modal */}
      <Modal show={showTransactionModal} onHide={() => setShowTransactionModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Transaction Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedTransaction && (
            <div>
              <Row className="mb-3">
                <Col md={6}>
                  <h6 className="text-muted">Transaction ID</h6>
                  <p className="fw-bold">{selectedTransaction.id}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted">Order ID</h6>
                  <p className="fw-bold">{selectedTransaction.order_id}</p>
                </Col>
              </Row>
              
              <Row className="mb-3">
                <Col md={6}>
                  <h6 className="text-muted">Transaction Date</h6>
                  <p className="fw-bold">
                    {new Date(selectedTransaction.transaction_date).toLocaleDateString()}
                  </p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted">Transaction Time</h6>
                  <p className="fw-bold">
                    {selectedTransaction.transaction_time ? 
                      new Date(`1970-01-01T${selectedTransaction.transaction_time}`).toLocaleTimeString('en-US', {
                        hour: 'numeric',
                        minute: '2-digit',
                        hour12: true
                      }) : 'N/A'
                    }
                  </p>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <h6 className="text-muted">Transaction Type</h6>
                  <Badge bg={selectedTransaction.transaction_type === 'CREDIT' ? 'success' : 'danger'}>
                    {selectedTransaction.transaction_type}
                  </Badge>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted">Transaction SubType</h6>
                  <p className="fw-bold">{selectedTransaction.txn_type}</p>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={4}>
                  <h6 className="text-muted">Amount</h6>
                  <p className={`fw-bold ${selectedTransaction.transaction_type === 'CREDIT' ? 'text-success' : 'text-danger'}`}>
                    ₹{selectedTransaction.amount?.toLocaleString()}
                  </p>
                </Col>
                <Col md={4}>
                  <h6 className="text-muted">Opening Balance</h6>
                  <p className="fw-bold">₹{selectedTransaction.opening_balance?.toLocaleString()}</p>
                </Col>
                <Col md={4}>
                  <h6 className="text-muted">Closing Balance</h6>
                  <p className="fw-bold">₹{selectedTransaction.closing_balance?.toLocaleString()}</p>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <h6 className="text-muted">Payment Mode</h6>
                  <p className="fw-bold">{selectedTransaction.payment_mode}</p>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <h6 className="text-muted">Collected By</h6>
                  <p className="fw-bold">
                    {selectedTransaction.collected_by_name || 'N/A'}
                    <br />
                    <small className="text-muted">{selectedTransaction.collected_by_mobile || '-'}</small>
                  </p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted">Created At</h6>
                  <p className="fw-bold">
                    {selectedTransaction.created_at ? new Date(selectedTransaction.created_at).toLocaleString() : 'N/A'}
                  </p>
                </Col>
              </Row>

              {selectedTransaction.notes && (
                <Row className="mb-3">
                  <Col md={12}>
                    <h6 className="text-muted">Notes</h6>
                    <p className="fw-bold">{selectedTransaction.notes}</p>
                  </Col>
                </Row>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowTransactionModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default FOSCollectionHistory;